import React from 'react';

export const DrawerStack = ({
  stack = [],
  registry = {},
  onClose = () => {},
  onSaved = () => {},
  submittingKey = null
}) => {
  if (!stack || stack.length === 0 || !registry) return null;
  return (
    <>
      {stack.map(entry => {
        const DrawerComponent = registry[entry.type];
        if (!DrawerComponent) {
          return null;
        }

        const handleClose = () => onClose(entry.key);
        const handleSaved = payload =>
          onSaved(
            {
              key: entry.key,
              type: entry.type,
              props: entry.props || {}
            },
            payload
          );

        return (
          <DrawerComponent
            key={entry.key}
            {...(entry.props || {})}
            onClose={handleClose}
            onSaved={handleSaved}
            isSubmitting={entry.key === submittingKey}
          />
        );
      })}
    </>
  );
};
